export default "//yastatic.net/s3/distribution/pythia/frontend/_/5443b06908165fc8880492e294174f70.png";